import axios from 'axios';
import { baseUrl_SPB } from '../BaseUrl';

const AddUnavailability = async (unavailability, token) => {
  const response = await axios.post(
    `${baseUrl_SPB}/api/v1/unavailability/save`,
    unavailability,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response?.data;
};

export default AddUnavailability;